import { QueryGroup } from "../api/generated/data-contracts"

const isNullOrEmpty = (group: QueryGroup) => {
	return group == null || !group.parts?.length;
}

export const queryGroupHelper = {
	isNullOrEmpty
}